import { IconButton, Box, Text } from '@nimbus-ds/components';
import { PencilIcon, TrashIcon } from '@nimbus-ds/icons';
import { DataList } from '@nimbus-ds/patterns';
import { useTranslationAccount } from 'domains/Account/hooks';
import { ExceptionProductsType } from '../../TaxExceptionsCard';

interface ExceptionsResultMobileProps {
  data: ExceptionProductsType[];
  handleEdit: (id: string) => void;
  handleDelete: (id: string) => void;
}

function ExceptionsResultMobile({
  data,
  handleEdit,
  handleDelete,
}: ExceptionsResultMobileProps) {
  const t = useTranslationAccount('businessDataPage.taxesWithExceptions.table');
  return (
    <div className="stratus--margins-expand">
      <DataList bottomDivider={false}>
        {data.map(({ id, description, products, iva_rate }) => (
          <DataList.Row key={id} gap="1">
            <Box
              display="flex"
              flexDirection="row"
              gap="2"
              justifyContent="space-between"
            >
              <Box display="flex" flexDirection="column" gap="1">
                <Text fontWeight="bold">{description}</Text>
                <Text>{t('quantityProducts', { count: products.length })}</Text>
              </Box>
              <Box display="flex" flexDirection="row" gap="6">
                <Box>
                  <Text>{iva_rate}%</Text>
                </Box>
                <Box display="flex" flexDirection="row" gap="2">
                  <IconButton
                    size="2rem"
                    source={<PencilIcon />}
                    onClick={() => handleEdit(id)}
                  />
                  <IconButton
                    size="2rem"
                    source={<TrashIcon />}
                    onClick={() => handleDelete(id)}
                  />
                </Box>
              </Box>
            </Box>
          </DataList.Row>
        ))}
      </DataList>
    </div>
  );
}

export default ExceptionsResultMobile;
